module.exports = "/_next/static/images/search_bg_29-ff201e0349a6e672fb5f00d8b89f0f2f.jpg";